// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryMutateHook on POST /contest/correction-review-resolve.

import {
  useMutation,
  useQueryClient,
  type QueryClient,
  type UseMutationOptions,
} from "@tanstack/react-query";
import type {
  typeContestCorrectionReviewResolveBody,
  typeContestCorrectionReviewResolveOutput200,
} from "../../sdk/contest/postContestCorrectionReviewResolve";
import useCallSdk from "../../sdk-helpers/useCallSdk";

type Options = Omit<
  UseMutationOptions<
    typeContestCorrectionReviewResolveOutput200,
    unknown,
    typeContestCorrectionReviewResolveBody,
    unknown
  >,
  "mutationFn"
>;

let invalidationTimer: ReturnType<typeof setTimeout> | null = null;

// 150ms of silence before invalidating: a burst of mutations (a row action
// repeated across a table selection) triggers one refetch, not one per call.
export function invalidateRelated({
  queryClient,
}: {
  queryClient: QueryClient;
}): void {
  if (invalidationTimer) {
    clearTimeout(invalidationTimer);
  }
  invalidationTimer = setTimeout(() => {
    void queryClient.invalidateQueries({
      queryKey: ["post:contest:contestCorrectionReviewGet", "svc:contest-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:standings:standingsGet", "svc:contest-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:results:resultsGetByRound", "svc:contest-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:round:roundGetBoard", "svc:contest-api"],
    });
  }, 150);
}

export default function useContestCorrectionReviewResolve(options?: Options) {
  const { callSdk } = useCallSdk();
  const queryClient = useQueryClient();
  const resolvedOptions = options ?? {};

  return useMutation({
    mutationFn: callSdk().postContestCorrectionReviewResolve,
    ...resolvedOptions,
    // TanStack Query v5 hands onSuccess four arguments
    // (data, variables, onMutateResult, context). Forward all four. Dropping
    // the last one makes the caller's own onSuccess a type error at every
    // generated mutation hook.
    onSuccess: (data, variables, onMutateResult, context) => {
      resolvedOptions.onSuccess?.(data, variables, onMutateResult, context);
      invalidateRelated({ queryClient });
    },
  });
}
